<div (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()" [class.collapsed]="collapsed"
  [class.open]="collapsed && collapsedOpen$ | async" class="sidenav flex flex-col ">
  <div class="sidenav-toolbar sidenav-items flex-none flex items-center ">

    <button type="button" (click)="navigateToDashboard()" class="puma-sidenav-brand" aria-label="PUMA home">
      <img src="assets/puma-logo.png" alt="PUMA" class="puma-sidenav-logo select-none flex-none" />
      <span class="puma-sidenav-label" aria-hidden="true">PUMA</span>
    </button>

    <!-- <button
      (click)="toggleCollapse()"
      *ngIf="showCollapsePin$ | async"
      class="w-8 h-8 -mr-2 leading-none flex-none hidden lg:block"
      mat-icon-button
      type="button"
    >
      <mat-icon
        *ngIf="!collapsed"
        [icIcon]="icRadioButtonChecked"
        size="14px"
      ></mat-icon>
      <mat-icon
        *ngIf="collapsed"
        [icIcon]="icRadioButtonUnchecked"
        size="14px"
      ></mat-icon>
    </button> -->

    <!-- <button
    (click)="toggleCollapse()"
    *ngIf="showCollapsePin$ | async"
    class="w-8 h-8 -mr-2 leading-none flex-none hidden lg:block"
    mat-icon-button
    type="button"
    [matTooltip]="collapsed ? 'Expand' : 'Collapse'"
  >
    <mat-icon 
      aria-hidden="true"
      [ngClass]="{ 'icon-collapsed': collapsed, 'icon-expanded': !collapsed }"
    >
      menu
    </mat-icon>
  </button> -->

  </div>

  <vex-scrollbar class="sidenav-navigation flex-auto">
    
      <vex-sidenav-item *ngFor="let item of items; trackBy: trackByRoute" [item]="item" [level]="0"></vex-sidenav-item>
   
  </vex-scrollbar>
</div>
